export default function ErrorPage() {
  return (
    <div className="ErrorComponentCSS">
      <h1>We are Working Hard</h1>
      <div>Apologies for 404</div>
    </div>
  );
}